module.exports = __webpack_public_path__ + "img/cover-catgunner.527c751f.png";